// ─── HUD layout + brand palette (Concepto B: módulos separados) ───────────────
//
// Presentation only. No gameplay data lives here and the hud:update payload is
// untouched — tune coordinates, widths, colors and brand labels here without
// changing HudScene logic. Coordinates are in the 720x1280 portrait space.
//
// The three meters keep their existing data sources; only their look/label/color
// changes so none can be confused with another:
//   ENERGIA  ← payload.musicEnergy (SongEnergySystem.ratio)  — brand green
//   INSTINTO ← payload.danger      (RunScene.danger)         — amber
//   AURA     ← payload.energy / 4  (PlayerController, champion charge) — teal

export const HUD_PALETTE = {
  panelFill: 0x050708,
  panelFillAlpha: 0.36,
  panelStroke: 0xb7ff00,
  panelStrokeAlpha: 0.18,
  divider: 0xb7ff00,
  dividerAlpha: 0.18,
  track: 0xffffff,
  trackAlpha: 0.08,
  timeText: "#f2f5eb",
  scoreText: "#dfff2f",
  labelMuted: "#8aa07c",
  // Per-meter colors: bar fill (number) + matching label (string), so the label
  // reinforces the meter color. ENERGIA also has a low-energy warning state.
  energia: { bar: 0xb7ff00, barLow: 0xffdd00, label: "#b7ff00", labelLow: "#ffdd00", lowThreshold: 0.28 },
  instinto: { bar: 0xff6a1a, label: "#ff6a1a" },
  aura: { bar: 0x1fe3c4, label: "#1fe3c4" }
} as const;

export const HUD_LAYOUT = {
  strip: { x: 12, y: 14, width: 696, height: 58, radius: 8 },

  // [ TIEMPO ] ┃ [ SCORE ] ┃ [ ENERGIA / INSTINTO / AURA ] ┃ [ ⏸ M ]
  // Rebalanced horizontally: TIEMPO/SCORE compacted (numbers don't need the
  // width) so the three meters and the button block get more room and air.
  //   TIEMPO 12–148 (136) · SCORE 148–268 (120) · METERS 268–588 (320) · BTNS 588–708 (120)
  dividers: [148, 268, 588],
  dividerTop: 22,
  dividerBottom: 64,

  time: {
    label: { x: 24, y: 20 },
    value: { x: 22, y: 32, fontSize: "24px" }
  },
  score: {
    label: { x: 160, y: 20 },
    value: { x: 160, y: 32, fontSize: "20px" }
  },

  meters: {
    iconX: 286,
    labelX: 304,
    barX: 430,
    barWidth: 150,
    barHeight: 7,
    trackHeight: 7,
    iconSize: 6.5,
    labelSize: "11px",
    fillAlpha: 0.85,
    // y-center of each stacked meter row inside the strip.
    rows: {
      energia: { y: 27, icon: "diamond", label: "ENERGIA" },
      instinto: { y: 43, icon: "triangle", label: "INSTINTO" },
      aura: { y: 59, icon: "orb", label: "AURA" }
    }
  },

  buttons: {
    // Larger glyph + padding for a finger-friendly touch area on mobile.
    fontSize: "18px",
    padding: { x: 13, y: 11 },
    pause: { x: 598, y: 20 },
    mute: { x: 652, y: 20 }
  },

  // Below the strip, centered, so they never cover gameplay.
  combo: { x: 360, y: 80 },
  storyHint: { x: 360, yRest: 100, yLift: 96 },
  debug: { x: 16, y: 120 }
} as const;

export type HudMeterIcon = "diamond" | "triangle" | "orb";
